export default __webpack_public_path__ + "static/media/Demon.98bacbd8.png";